require('./_typed-array')('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-polyfill/node_modules/core-js/modules/es6.typed.float64-array.js
// module id = ./node_modules/babel-polyfill/node_modules/core-js/modules/es6.typed.float64-array.js
// module chunks = 4